(function () {
  'use strict';

  var path = window.location.pathname.replace(/\/$/, '');
  var normalized = path.replace(/^\/en-gb/, '') || '/';
  if (normalized !== '/collections/pro-cookware') return;

  var url = new URL(window.location.href);
  var view = url.searchParams.get('view');
  var hackViews = {
    'pro-cookware-2026': 1,
    'pro-cookware-restore': 1,
    'pro-cookware-clean': 1,
    'pro-cookware-v2': 1,
    'pro-cookware-shop': 1,
    'pro-cookware-v4': 1
  };

  if (!view || !hackViews[view]) return;

  url.searchParams.delete('view');
  if (url.searchParams.get('sort_by') === 'best-selling') {
    url.searchParams.delete('sort_by');
  }
  window.location.replace(url.pathname + url.search + url.hash);
})();
